import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XCircle, ChevronDown } from 'lucide-react';
const painPoints = [{
  title: 'Llegás a la visita sin saber qué cobrar:',
  desc: 'Sin una estructura clara para desglosar los costos frente al cliente.'
}, {
  title: 'Presupuestos que no cierran:',
  desc: 'Enviás la cotización tres días tarde y el cliente ya contrató a otro o dice que "es caro".'
}, {
  title: 'Perdés dinero en los imprevistos:',
  desc: 'Modificaciones en la obra que terminás pagando de tu propio bolsillo por no aclararlas antes.'
}, {
  title: 'Siempre el mismo margen de ganancia bajo:',
  desc: 'No sabés cómo justificar el valor de tu mano de obra calificada frente a la competencia informal.'
}, {
  title: 'El cierre se vuelve inalcanzable:',
  desc: 'Te falta un sistema de venta consultiva para que el cliente entienda la transformación de su espacio.'
}, {
  title: 'Falta de seguimiento profesional:',
  desc: 'Dejás el presupuesto en el aire y no sabés cómo reactivar al cliente sin parecer pesado por WhatsApp.'
}, {
  title: 'Clientes que cambian las condiciones:',
  desc: 'Te exigen terminaciones premium o tareas extra que no estaban incluidas en el "pacto de palabra".'
}, {
  title: 'Fin de mes sin rentabilidad:',
  desc: 'Entre el 60% y el 68% de tus presupuestos se pierden en el limbo de la indecisión.'
}];
export function PainPoints() {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  return <section className="py-10 sm:py-16 lg:py-24 bg-rose-50" data-id="element-123">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-124">
        <div className="text-center mb-8 sm:mb-12" data-id="element-125">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-3 sm:mb-4 text-[#305DAA]" data-id="element-126">
            ¿TE PASA ESTO?
          </h2>
          <p className="text-base sm:text-lg text-gray-600" data-id="element-127">
            Si hacés remodelaciones y obras en Argentina, esto te suena
            familiar:
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-8 sm:mb-12" data-id="element-128">
          {painPoints.map((point, index) => {
          const isExpanded = expandedIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} className="bg-gray-50 rounded-lg border border-gray-100 overflow-hidden" data-id="element-129">
                <button onClick={() => setExpandedIndex(isExpanded ? null : index)} className="w-full flex items-center justify-between p-4 text-left focus:outline-none hover:bg-gray-100 transition-colors" data-id="element-130">
                  <div className="flex items-center" data-id="element-131">
                    <XCircle className="w-5 h-5 text-red-500 mr-3 flex-shrink-0" data-id="element-132" />
                    <span className="font-bold text-brand-dark text-sm sm:text-base" data-id="element-133">
                      {point.title}
                    </span>
                  </div>
                  <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform ${isExpanded ? 'rotate-180' : ''}`} data-id="element-134" />
                </button>

                <AnimatePresence data-id="element-135">
                  {isExpanded && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2
              }} data-id="element-136">
                      <div className="px-4 pb-4 pt-1 ml-8 text-sm text-gray-600" data-id="element-137">
                        {point.desc}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center p-5 sm:p-6 bg-brand-dark rounded-xl text-white shadow-lg" data-id="element-138">
          <p className="text-lg sm:text-xl md:text-2xl font-bold" data-id="element-139">
            ¿Cuántos meses más vas a seguir perdiendo obras por improvisar tus
            números?
          </p>
        </motion.div>
      </div>
    </section>;
}